<mat-card style="margin-top:30px;margin-left:10px;margin-right:10px;width:99.5%;height:100%;;min-height: 450px;">
    <div class="container-fluid">
       
        <hr/>

        <div class="row">
            <span style="margin-left:0px;margin-top:5px;margin-bottom:20px;"  class="lanai-page-title">Create Invoice Line</span>
        </div>
        @if (activeTaxListForLot.length > 0) {
            <mat-radio-group aria-label="Select an option">
                <mat-radio-button value="0" [checked]="isNetCalcMode" (click)="onToggleNetGrossMode()">Net</mat-radio-button>
                <mat-radio-button value="1"  (click)="onToggleNetGrossMode()" [checked]="!isNetCalcMode">Gross</mat-radio-button>
            </mat-radio-group>
        }

        <form 
        (ngSubmit)="onSubmitNewInvoiceLine()" 
        novalidate
        [formGroup]="invoiceLineForm" 
        style="margin-top:10px;">

            <span class="ace-heading-text-secondary">Calculate by Entering {{netGrossLabel}} Rate</span>
            <div class="row" style="margin-top:20px;">
                <div class="col-3">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Revenue Type</mat-label>
                        <mat-select formControlName="revenueCode" (selectionChange)="onRevenueTypeChange()">
                          <mat-option value="">Select Revenue Type</mat-option>
                            @for (revenueType of filteredRevenueTypes; track revenueType.code + '-' + $index) {
                                <mat-option [value]="revenueType.code" >
                                    {{revenueType.description}}
                                </mat-option>
                            }
                        </mat-select>
                        <mat-error *ngIf="invoiceLineForm.get('revenueCode')!.hasError('required')">The Reveue Type is required</mat-error>
                      </mat-form-field>
                </div>
                
                 <div class="col-1">
                        <!-- 20260824 :: Ken Moss -->
                        <!-- This is a temporary patch per Josh Izigzon to handle an error on legacy APN application admin feature. -->
                        <!-- If the selected revenue code is 'PAYRM', do not show the tax applied checkbox.  -->
                            @if(activeTaxListForLot.length > 0){
                                @if(selectedRevenueCode?.toUpperCase() !== 'PAYRM'){
                                    <div style="margin-left:0px;margin-top:10px;">
                                        <mat-checkbox formControlName="isTaxable" (mousedown)="onTaxableMouseDown()" (click)="onEvalTaxApplied($event)">Tax Applied?</mat-checkbox>
                                    </div>
                                }
                            }
                           @else {
                            --
                           }
                </div>
              
                <div class="col-1">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>{{netGrossLabel}} Rate</mat-label>
                        <input id="grossRate" 
                        type="text"
                        (blur)="onCalculateRateData()" 
                        (input)="onRateInput($event)"
                        formControlName="rate"
                        twoDigitDecimaNumberDirective
                            matInput placeholder="Rate"
                            inputmode="decimal"
                            onfocus="this.select()"
                            />
                            <mat-error *ngIf="invoiceLineForm.get('rate')!.hasError('required')">The Rate is required</mat-error>
                            <mat-error *ngIf="invoiceLineForm.get('rate')!.hasError('min')">The Rate must be greater/equal to $0.01</mat-error>
                            <mat-error *ngIf="invoiceLineForm.get('rate')!.hasError('pattern')">The Rate can only contain numbers and a decimal</mat-error>
                        </mat-form-field>
                </div>
                
                <div class="col-1" style="font-size:12px;">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Quantity</mat-label>
                        <input id="quantityForGross" 
                        formControlName="quantity"
                            (input)="onQuantityInput($event)"
                            matInput placeholder="Quantity"
                            aceNumericOnly
                            inputmode="numeric"
                            onfocus="this.select()">
                        <mat-error *ngIf="invoiceLineForm.get('quantity')!.hasError('required')">The Quantity is required</mat-error>
                        <mat-error *ngIf="invoiceLineForm.get('quantity')!.hasError('min')">The Quantity must be 1 or more</mat-error>
                        <mat-error *ngIf="invoiceLineForm.get('quantity')!.hasError('pattern')">The Quantity cannot be a decimal</mat-error>
                      </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Description</mat-label>
                        <input matInput placeholder="Description" id="revenueDescription" formControlName="description" maxlength="500" style="font-size:14px;">
                        <mat-error *ngIf="invoiceLineForm.get('description')!.hasError('required')">The Description is required</mat-error>
                      </mat-form-field>
                </div>

                <div class="col-1">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Seq Start</mat-label>
                        <input 
                        type="text"
                        formControlName="sequenceStart"
                            matInput placeholder="Sequence Start"
                            onfocus="this.select()"
                            (blur)="this.onValidateSequenceNumbers()"
                            />
                            <mat-error *ngIf="invoiceLineForm.get('sequenceStart')!.hasError('pattern')">The Sequence Start can only contain numbers</mat-error>
                            <mat-error *ngIf="invoiceLineForm.get('sequenceStart')!.hasError('sequenceStartRequired')">The Sequence Start is required because the Sequence End has a value</mat-error>
                      </mat-form-field>
                </div>

                <div class="col-1">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Seq End</mat-label>
                        <input 
                        type="text"
                        formControlName="sequenceEnd"
                            matInput placeholder="Sequence End"
                            onfocus="this.select()"
                            (blur)="this.onValidateSequenceNumbers()"
                            />
                            <mat-error *ngIf="invoiceLineForm.get('sequenceEnd')!.hasError('pattern')">The Sequence End can only contain numbers</mat-error>
                            <mat-error *ngIf="invoiceLineForm.get('sequenceEnd')!.hasError('sequenceEndRequired')">The Sequence End is required because the Sequence Start has a value</mat-error>
                            <mat-error *ngIf="invoiceLineForm.get('sequenceEnd')!.hasError('sequenceEndLessThanStart')">The Sequence End must be greater than the Sequence Start value</mat-error>
                      </mat-form-field>
                </div>
            
        </div>
        </form>

            <div style="margin-top:30px">
                <div class="row" style="margin-top:5px;">
                    <div class="col-3" style="font-size:14px;">
                        <span class="ace-heading-text-tabs-level-2">Invoice Line Calculation Results for {{netGrossLabel}} Rate:</span>
                    </div>
                </div>    

            </div>
            <div class="row" style="margin-top:5px;">
                <!-- <div class="col-1" style="font-size:18px;"><strong>{{netGrossLabel}} Results:</strong></div> -->
                <div class="col-3" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Rate</mat-label>
                        <input matInput placeholder="Rate" [ngModel]="lotParkingRate | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Tax Rate %</mat-label>
                        <input matInput placeholder="Tax Rate" [ngModel]="displayTaxRate | percent:'2.2-2'" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Total Net</mat-label>
                        <input matInput placeholder="Tax Rate" [ngModel]="displayNetAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Tax</mat-label>
                        <input matInput placeholder="Tax" [ngModel]="displayTaxAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
                
                <div class="col-3" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Total Gross</mat-label>
                        <input matInput placeholder="Tax" [ngModel]="displayGrossAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
            </div>
            <div class="row" style="margin-top:0px;">
                <div class="col-2" style="font-size:12px;">
                    <button type="submit" class="btn btn-primary btn-sm ace-blue" style="margin-left:20px;margin-top:20px;" (click)="onSubmitNewInvoiceLine()" [disabled]="!invoiceLineForm.valid">Add Invoice Line</button>
                    <button type="button" class="btn btn-primary btn-sm ace-blue" style="margin-left:20px;margin-top:20px;" (click)="onResetInvoiceLine()">Clear</button>
                </div>
            </div>
    </div>
</mat-card>




